import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';
import { UsersContext } from '../../contexts/Users';
import { formatDate } from '../../utils/format-date';
import * as CSS from './elements/Completion';

const SummativeComment = observer(({ summary, heading = 'Summary' }) => {
  const usersStore = useContext(UsersContext);
  if (!summary) return null;
  const author = usersStore.getUserById(summary.createdBy);

  return (
    <CSS.SummaryContainer data-testid="SummativeComment">
      <CSS.SummaryHeading>{heading}</CSS.SummaryHeading>
      <CSS.SummaryText>{summary.text}</CSS.SummaryText>
      <CSS.SummaryMeta>
        {author?.displayName || 'Your teacher'} ·{' '}
        {formatDate(summary.createdAt)}
      </CSS.SummaryMeta>
    </CSS.SummaryContainer>
  );
});

export default SummativeComment;
